export class TicketService {
    static TicketSelected;
    static LastPage;
}